import { AfterViewInit, Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AuthService } from 'src/app/shared/service/auth/auth.service';
import { ParameterService } from 'src/app/shared/service/params/param';


@Component({
  selector: 'app-passwordreset',
  templateUrl: './passwordreset.component.html',
  styleUrls: ['./passwordreset.component.scss']
})

/**
 * Reset-password component
 */
export class PasswordresetComponent implements OnInit, AfterViewInit {

  resetForm: UntypedFormGroup;
  submitted = false;
  error = '';
  success = '';
  loading = false;

  // set the currenr year
  year: number = new Date().getFullYear();

  constructor(
    private authService: AuthService,
    private messageService: MessageService,
    private router: Router,
    private paramService: ParameterService,

  ) { }

  configMairie: any = {};

  ngOnInit() {

  this.getLogoNomCommune();
  }



  ngAfterViewInit() {
  }


  item: any
  onSubmit() {

    if (!this.item) {
      this.messageService.add({ severity: 'error', summary: 'X-Project', detail: "Veuillez fournir une adresse mail valide" });
      return;
    }
    this.authService.reset(this.item).subscribe(

      (response: any) => {

        this.messageService.add({ severity: 'success', summary: 'X-Project', detail: response.message });

        this.router.navigate(['/login'])
      },
      (error) => {
        const errorMessage = error?.error?.message
            || error?.error?.error
            || error?.message
            || 'Une erreur est survenue';
        this.messageService.add({ severity: 'error', summary: 'X-Project', detail: errorMessage });

      }
    )
  }

  logo:any;
  commune:any;



  getLogoNomCommune() {

    this.paramService.getParamatrageCommune().subscribe(
      (response: any) => {
      //*  */  console.log("le logo du webservice", response);
        this.configMairie = response.data
          this.logo = this.configMairie?.logo?.value;
          this.commune = this.configMairie?.commune?.value;
      },
      (error: any) => {
        // console.log("une erreur est survenu", error);

      }
    )
  }

  onImageError(event: Event): void {
    const target = event.target as HTMLImageElement;
    target.src = '../../../assets/new-accueil/logo-vrai.png';
  }
}
